import { setEstimationExist } from 'shared/actions/valuationTraps/actions';
import { addressSelector } from 'shared/selectors';
import { fetchEstimationExist } from 'shared/services/valuationTraps/fetchEstimationExist';
import { IThunkActionCreator } from 'shared/store';

export const getEstimationExist = (): IThunkActionCreator<Promise<void>> => async (dispatch, getState, context) => {
  const address = addressSelector(getState());
  const addressString = address.map(addr => addr.fullName).join(', ');

  try {
    const res = await fetchEstimationExist(context, addressString);

    dispatch(setEstimationExist(res));
  } catch (e) {
    dispatch(setEstimationExist(false));
  }
};
